module.exports = __webpack_public_path__ + "img/appliance_repair.98ad61a2.png";